const digest = '291517a28455ab33af0fa57e67aa261f8ffcedec17d1671b76c7a4955e0993b3';
const css = `._main_1t13y_1{margin:0 auto;max-width:1000px;padding:1rem;width:100%}@media screen and (min-width:1024px){._list_1t13y_9{display:flex;justify-content:center;position:relative}}._listItem_1t13y_16{width:100%}@media screen and (min-width:1024px){._listItem_1t13y_16{width:33%}._listItem_1t13y_16:not(:last-child):after{left:calc(50% - 14px);position:absolute;top:10px}}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'main': '_main_1t13y_1', 'list': '_list_1t13y_9', 'listItem': '_listItem_1t13y_16' };
export const main = '_main_1t13y_1';
export const list = '_list_1t13y_9';
export const listItem = '_listItem_1t13y_16';
export { css, digest };